import * as $ from "jquery";
import * as _ from "lodash";
import { Utils } from "../../../../common/utils";
import { DashboardChannel } from "../../../../models/DashboardChannel";
import { ChartWorkerManager } from "../ChartWorkerManager";
import { BaseDashboardWidgetViewOptions } from "../_BaseWidgetView";
import { CHART_AGGREGATION_PERIOD, CHART_AGGREGATION_TYPE, CHART_TYPE } from "../chart/ChartHelper";
import { SimpleWidget } from "../simplewidget/SimpleWidget";
import { WIDGET_DIMENSIONS } from "../../../../common/widgetLayout";
const moment = require("moment-timezone");

declare var App: any;

export class SensitivityWidget extends SimpleWidget {
    protected channelsTemplate = _.template(require('templates/dashboard/widgets/sensitivity/channels.html'));
    protected chartWorkerManager = new ChartWorkerManager({
        dashboardChannelCollection: this.options.dashboardChannelCollection
    });
    protected thresholdsExceeded = null;
    private isUpdating = false;
    private hideSkeletonDebounced = _.debounce(() => {
        this.hideSkeleton();
    }, 50);

    constructor(options: BaseDashboardWidgetViewOptions) {
         super(<any> _.extend(options, {
            className: "widget widget-w-2",
            events: {
                'click .change-sentitvity-level': '_handleSliderUpdate'
            }
        }));

        this.handleSliderUpdate = _.debounce(() => {
            this._handleSliderUpdate();
        }, 300);
    }

    render() {
        // Call parent render but override the widget size logic
        super.render();
        
        // Sensitivity widget should always be widget-w-2, regardless of WIDGET_SIZE parameter
        this.$el.removeClass('widget-w-1 widget-w-2');
        this.$el.addClass('widget-w-2');
        
        return this;
    }

    protected renderChannels() {
        const rawUseCustomLabelsConfig = this.options.widget.getParamValue('USE_CUSTOM_LABELS', false);
        const useCustomLabels = !!Number(rawUseCustomLabelsConfig);

        var aggPeriod = this.options.widget.getParamValue("CHART_AGGREGATION_PERIOD", "");
        if (aggPeriod && aggPeriod !== "NONE") {
            var d = this.aggregationWidgetManager.checkAggregation();
        } else {
            var d = $.Deferred().resolve();
        }

        $.when(d).then((valueOverrides) => {
            var channels = this.options.dashboardChannelCollection.where({ dashboard_widget_id: this.options.widgetId });
            var channelsToRender = [];
            var sorted = _.sortBy(channels, (c) => {
                return c.get("dashboard_channel_order");
            });

            var values = {};
            _.each(sorted, (channel: any) => {
                var id = channel.get('dashboard_channel_id');
                values[id] = {};
                if (valueOverrides && valueOverrides[id]) {
                    const lastValue = _.last(_.last(valueOverrides[id]));
                    const lastValueFormatted = Utils._getFormattedValue(
                        lastValue,
                        channel.get("sensor_type"),
                        channel.get("sensor_version"),
                        Utils._getFormatDecimals(channel.get("channel_decimals"), channel.get("channel_converted_value")),
                        channel.get("channel_conversion_function_name")
                    );
                    values[id] = Utils.validateFormattedValue(lastValueFormatted);
                } else {
                    const value = channel.get("channel_formatted_value");
                    values[id] = Utils.validateFormattedValue(value);
                }
            });

            _.each(sorted, (channel: any) => {
                var lastSeenStr = Utils.Time.getChannelLastSeenString(channel.get("channel_last_timestamp"));
                var lastSeenColor = Utils.Time.getChannelLastSeenColor(channel.get("channel_last_timestamp"));
                var isChannelLastSeenStale = Utils.Time.isChannelLastSeenStale(channel.get("channel_last_timestamp"));
                var channelLastSeenOpacity = Utils.Time.getChannelLastSeenOpacity(channel.get("channel_last_timestamp"));
                var state = this.getStateFromRange(channel);
                
                let channelName = channel.get("dashboard_channel_name");
                if (!useCustomLabels)
                    channelName = `${channel.get("module_location")} - ${channel.get("channel_name")}`;

                var id = channel.get("dashboard_channel_id");
                var clicked = _.includes(this.channelsSelected, id);
                channelsToRender.push({
                    name: channelName,
                    unit: channel.get("channel_unit"),
                    value: values[id],
                    color: clicked ? "#FFF" : state.color,
                    fontColor: clicked ? "#FFF" : "#333333",
                    backgroundColor: clicked ? state.color : "#F8F8F8",
                    statusColor: state.color,
                    state: state.name,
                    thresholdCrossed: state.arrow,
                    lastSeen: lastSeenStr,
                    lastSeenColor: lastSeenColor,
                    isChannelLastSeenStale: isChannelLastSeenStale,
                    channelLastSeenOpacity: channelLastSeenOpacity,
                    icon: this.getIcon(channel),
                    id: id,
                    clicked: clicked,
                });
            });

            if (channelsToRender.length) {
                this.$el.removeClass("hidden");
                this.renderChannelsTemplate({
                    channels: channelsToRender,
                    widget: this.options.widget,
                });

                this.syncChannelsWithChart(() => {
                    this.$(".simple-widget-channel").removeClass("clicked");
                    _.each(this.channelsSelected, (channelId) => {
                        this.$(`[data-channel-id="${channelId}"]`).addClass("clicked");
                    });
                });

                // Calculate height: selector (124px) + channel table based on count
                const channelCount = channelsToRender.length;
                const selectorHeight = WIDGET_DIMENSIONS.BASE_HEIGHT;
                const channelsHeight = WIDGET_DIMENSIONS.getSimpleWidgetHeight(channelCount);
                const totalHeight = selectorHeight + channelsHeight;
                
                this.$('.body.w-channels').css('height', totalHeight + 'px');
            } else {
                this.$el.addClass("hidden");
            }

            var renderedChannelIds = <number[]>_.map(channelsToRender, "id");
            if (
                this.lastRenderedChannelIds.length !== renderedChannelIds.length ||
                _.difference(this.lastRenderedChannelIds, renderedChannelIds).length !== 0
            ) {
                window["App"].Bus.trigger("dashboard:category:" + this.options.categoryId + ":layout");
            }

            this.lastRenderedChannelIds = renderedChannelIds;
            this.hideSkeletonDebounced();
        });
    }

    protected renderChannelsTemplate(options) {
        var levels = JSON.parse(this.options.widget.getParamValue('SENSITIVITY_LEVELS', '[]'));
        var activeLevel = this.options.widget.getParamValue('SENSITIVITY_ACTIVE', '');
        var activeIndex = _.indexOf(levels, activeLevel);

        // Channels are already enhanced with opacity data from renderChannels()
        this.$('.w-rows').html(this.channelsTemplate(_.extend({
            sensitivityLevel: activeLevel,
            sliderIndex: activeIndex,
            sliderMax: levels.length - 1,
            sliderLength: levels.length,
            thresholdsExceeded: this.thresholdsExceeded,
            editable: this.options.editable
        }, options)));

        // Content is ready, hide skeleton and show content
        this.hideSkeleton();

        (<any>this.$el.find('[data-slider="slider"]')).slider();
        this.$el.find('[data-slider="slider"]').on('change', (e: JQuery.Event) => {
            this.handleSliderUpdate();
        });

        this.computeExceededThresholds();
    }

    private handleSliderUpdate() {
    } // debounced
   private _handleSliderUpdate(event?: Event) {
        if (!this.options.editable || this.isUpdating) return;

        const levels = JSON.parse(this.options.widget.getParamValue('SENSITIVITY_LEVELS', '[]'));
        const currentActiveLevel = this.options.widget.getParamValue('SENSITIVITY_ACTIVE', '');
        
        let sliderIndex: number;
        
        if (event) {
          const $target = $(event.currentTarget);
          sliderIndex = parseInt($target.data('slider-value'), 10);
        } else {
          // fallback: get current value from parent container
          const $container = this.$('[data-current-slider-value]');
          sliderIndex = parseInt($container.data('current-slider-value'), 10);
        }
    
        // Validate and clamp sliderIndex
        if (isNaN(sliderIndex) || sliderIndex < 0 || sliderIndex >= levels.length) return;
    
        const newActiveLevel = levels[sliderIndex];
        if (!newActiveLevel || newActiveLevel === currentActiveLevel) return;

        // Show skeleton during update
        this.isUpdating = true;
        this.showSkeleton();

        App.Bus.trigger('dashboard:update:suspend');

        var update = {};
        var channels = <DashboardChannel[]>this.options.dashboardChannelCollection.where({
            dashboard_widget_id: this.options.widgetId
        });
        var newActiveIndex = _.indexOf(levels, newActiveLevel);
        var sensitivityValues = JSON.parse(this.options.widget.getParamValue('SENSITIVITY_VALUES', '{}'));
        _.each(channels, (channel) => {
            var dashboardChannelId = channel.get('dashboard_channel_id');
            var channelId = channel.get('channel_id');
            var rangesList = sensitivityValues[dashboardChannelId][newActiveIndex];

            update[dashboardChannelId] = {
                dashboardId: this.options.dashboardId,
                widgetId: this.options.widgetId,
                channelId: channelId,
                order: channel.get('dashboard_channel_order'),
                name: channel.get('dashboard_channel_name'),
                critLow: null,
                warnLow: null,
                warnHigh: null,
                critHigh: null,
                rangesList: rangesList
            }
        });

        this.options.widget.setParamValue('SENSITIVITY_ACTIVE', newActiveLevel);
        this.options.widget.save().then(() => {
            return $.ajax({
                type: "PUT",
                url: this.options.dashboardChannelCollection.url(),
                data: JSON.stringify({
                    'delete': [],
                    create: [],
                    update: update
                }),
                dataType: 'json',
                contentType: "application/json; charset=utf-8"
            })
        }).then(() => {
                return this.options.dashboardChannelCollection.fetch();
            })
            .then(() => {
                App.Bus.trigger('dashboard:config:changed');
                App.Bus.trigger('dashboard:update:resume');
                this.isUpdating = false;
            })
            .fail((error) => {
                App.Bus.trigger('dashboard:update:resume');
                this.isUpdating = false;
                this.hideSkeleton();
            });
    }

    private showSkeleton() {
        this.$('.sensitivity-skeleton').removeClass('tw-hidden');
        this.$('.sensitivity-content').addClass('tw-hidden');
    }

    private hideSkeleton() {
        this.$('.sensitivity-skeleton').addClass('tw-hidden');
        this.$('.sensitivity-content').removeClass('tw-hidden');
    }

    private computeExceededThresholds() {
        var end = moment().endOf('day');
        var start = moment(end).subtract(7, 'days');
        var channels = <DashboardChannel[]>this.options.dashboardChannelCollection.where({
            dashboard_widget_id: this.options.widgetId
        });
        var series = {};
        _.each(channels, (c) => {
            var channelId = c.get('channel_id');
            series[channelId] = { name: '', channelId: channelId, tag: channelId, agg: CHART_AGGREGATION_TYPE.NONE };
        });


        this.chartWorkerManager.reset();
        this.chartWorkerManager.getSeries({
            chartConfig: {
                seriesGroups: [{
                    period: CHART_AGGREGATION_PERIOD.NONE,
                    type: CHART_TYPE.LINE,
                    series: _.values(series)
                }],
                timezone: this.options.currentUser.get('timezone'),
                showThresholdPlotlines: false,
                realTimestamps: true,
                hideSingleGaps: false,
                convertAllValues: true,
                labels: false
            },
            startTimestamp: start.unix(),
            endTimestamp: end.unix(),
            keepData: true,
            dashboardChannelIds: _.map(channels, (c) => c.get('dashboard_channel_id')),
        }, (err, channelData) => {
            var thresholdsExceeded = 0;
            var tresholdCurrentlyExceeded = false;

            _.each(channels, (c) => {
                var cId = c.get('channel_id');
                if (!_.has(channelData, cId)) return;

                _.each(channelData[cId], (dataPoint) => {
                    var value = dataPoint[1];

                    var activeRange = c.getRange(value)
                    if (!activeRange.get('is_default')) {
                        if (!tresholdCurrentlyExceeded) {
                            thresholdsExceeded++;
                            tresholdCurrentlyExceeded = true;
                        }
                    } else {
                        tresholdCurrentlyExceeded = false;
                    }
                });
            });
            this.thresholdsExceeded = thresholdsExceeded;
            this.$('.sensitivity .sensitivity__samples').text(thresholdsExceeded);
            this.$('.sensitivity .sensitivity__bottom').removeClass('hidden');
        });
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/dashboard/widgets/sensitivity/SensitivityWidget.ts